import type { NextRouter } from 'next/router';

import { validateMfaToken } from '../lib/api';
import type { PortalUser } from '../types/user';
import { Config } from '../services/Config';

import { extractRedirectURLFromPath } from './utils';

export const routerSingleParam = (param?: string | string[]) => {
  return typeof param === 'string'
    ? param
    : Array.isArray(param)
    ? param[0]
    : undefined;
};

export function urlSafeDecode(hex: string) {
  if (hex && hex.match(/.{2}/g)) {
    return (hex.match(/.{2}/g) as Array<string>)
      .map(function (char: string) {
        return String.fromCharCode(parseInt(char, 16));
      })
      .join('');
  }
  return hex || '';
}

export const getClientData = (router: NextRouter) => {
  // let clientId;
  let clientRedirect;
  const defaultRedirect =
    Config.APPLICATION_AUTH_WEBCLIENTID_PORTAL_REDIRECTURL;
  if (typeof window !== 'undefined') {
    // read client_id from path
    // hack to wait route query to be ready
    if (router.asPath !== router.route) {
      if (router && router.asPath && router.asPath.includes('redirect_url')) {
        const { redirectURL } = extractRedirectURLFromPath(router.asPath);
        if (redirectURL) {
          clientRedirect = redirectURL;
          try {
            const isDomainWhiteListed = checkIfDomainIsWhiteListed(
              new URL(decodeURIComponent(clientRedirect)).host
            );

            if (!isDomainWhiteListed) {
              // TODO: Redirect to portal or ask Emma what to do.
              // window.location.href =
              //   Config.APPLICATION_AUTH_WEBCLIENTID_PORTAL_DOMAIN;
              router.push('/404');
            }

            const clientState = router?.query?.state as string;

            localStorage.setItem('clientRedirect', clientRedirect);
            localStorage.setItem('clientState', clientState);
            return [clientRedirect, clientState];
          } catch (error) {
            console.error('redirect failed', error);
            // TODO: Redirect to portal or ask Emma what to do.
            // window.location.href =
            //   Config.APPLICATION_AUTH_WEBCLIENTID_PORTAL_DOMAIN;
            router.push('/404');
          }
        }
        // or read hash params and clientid from storage
        else if (
          router.asPath &&
          router.asPath.includes('#') &&
          (router.asPath.includes('id_token') ||
            router.asPath.includes('error_description'))
        ) {
          clientRedirect = localStorage.getItem('clientRedirect') || '';
          if (!redirectURL) {
            return [];
          }
        } else {
          // if redirectUrl can not be parsed
          return [defaultRedirect];
        }
        return [clientRedirect, localStorage.getItem('clientState')];
      }
      return [defaultRedirect];
    }
  }
};

export function checkIfDomainIsWhiteListed(urlToCheck: string) {
  return Config.APPLICATION_AUTH_WEBCLIENTID_WHITELISTDOMAINS.some((domain) => {
    return urlToCheck.includes(domain);
  });
}

export const requireMFASetup = (user: PortalUser | null) => {
  return user?.mfaRequired && !user.mfaEnabled;
};

export const requireMFAValidation = async (
  user: PortalUser,
  mfaToken?: string
) => {
  if (!mfaToken) {
    return true;
  }

  const resp = await validateMfaToken(mfaToken, user.token);
  return !(resp && resp.result === 'success');
};
